import { render } from "./Lotto7.vue?vue&type=template&id=6b9019c4&scoped=true"
import script from "./Lotto7.vue?vue&type=script&lang=js"
export * from "./Lotto7.vue?vue&type=script&lang=js"

import "./Lotto7.vue?vue&type=style&index=0&id=6b9019c4&scoped=true&lang=css"

import exportComponent from "/home/gitlab-runner/builds/5rs1AT96L/0/prj/cashier/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b9019c4"]])

export default __exports__